import { render, staticRenderFns } from "./addPlatFormAdmin.vue?vue&type=template&id=3e0b80d6&scoped=true&"
import script from "./addPlatFormAdmin.vue?vue&type=script&lang=js&"
export * from "./addPlatFormAdmin.vue?vue&type=script&lang=js&"
import style0 from "./addPlatFormAdmin.vue?vue&type=style&index=0&id=3e0b80d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b80d6",
  null
  
)

export default component.exports